<template>
    <section id="project-header" class="grid-section">
      <transition appear name="slide-left">
        <a href="#" @click="goBack" id="history-back">
          <img src="@/assets/svg/arrow-left.svg" alt="back">
        </a>
      </transition>
      <div class="client">
        <transition appear name="slide-left">
          <div class="transition-wrapper">
            <h2>{{ client }}</h2>
            <p>{{ product }}</p>
          </div>
        </transition>
      </div>
      <div class="client-header-right">
        <transition appear name="slide-right">
          <ul class="tasks">
            <li v-for="t in tasks" v-bind:key="t.id">
              {{ t }}
            </li>
          </ul>
        </transition>
      </div>
      <transition appear name="slide-top">
        <a href="#" v-scroll-to="'#project-intro'" class="scroll-me" >
          <img src="@/assets/svg/arrow-down.svg" alt="scroll down">
        </a>
      </transition>
    </section>
</template>
<script>
export default {
  name: "Project",
  props: {
    client: String,
    product: String,
    tasks: Object,
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    }
  }
}
</script>

<style scoped>

#project-header {
  height: 80vh;
  margin: 0;
  padding-bottom: 10vh;
}

#history-back {
  position: fixed;
  left: 1.4rem;
  top: 5rem;
}

.client {
  grid-column: 2 / 5;
  grid-row: 6 / 7;
  align-self: end;
  overflow: hidden;
}

.client h2 {
  margin-left: -0.5rem;
  font-size: 7.5rem;
  font-weight: 700;
  line-height: 100%;
}

.client-header-right {
  overflow: hidden;
  grid-column: 5 / 6;
  grid-row: 6 / 7;
  align-self: end;
}

.tasks {
  text-align: right;
}

.scroll-me {
  grid-column: 1 / 2;
  grid-row: 6 / 7;
  padding-right: 1.4rem;
  padding-left: 1.4rem;
  justify-self: right;
  align-self: end;
}

</style>
